// ChatBubble — balão de mensagem para chat
import { h, ComponentChildren } from 'preact';
import { T } from '../../styles/tokens';

interface ChatBubbleProps {
  isUser: boolean;
  children: ComponentChildren;
  timestamp?: string;
  tokensIn?: number;
  tokensOut?: number;
  costUsd?: number;
  durationMs?: number;
  isPending?: boolean;
  animate?: boolean;
}

export function ChatBubble({ isUser, children, timestamp, tokensIn, tokensOut, costUsd, durationMs, isPending, animate }: ChatBubbleProps) {
  return (
    <div style={{
      display: 'flex', justifyContent: isUser ? 'flex-end' : 'flex-start',
      padding: '0 12px', animation: animate ? 'msgIn 0.2s ease-out' : 'none',
    }}>
      <div style={{
        maxWidth: '80%', padding: '10px 14px',
        borderRadius: isUser ? '18px 18px 4px 18px' : '18px 18px 18px 4px',
        background: isUser ? `linear-gradient(135deg, ${T.primary}, #6D4CFF)` : T.bgCard,
        border: isUser ? 'none' : `1px solid ${T.bgHover}`,
        color: T.text,
      }}>
        {children}

        {/* Footer: timestamp + tokens + custo + duração */}
        {(timestamp || tokensIn != null) && (
          <div style={{
            fontSize: 10, marginTop: 4, display: 'flex', alignItems: 'center', gap: 6,
            color: isUser ? T.textMuted : T.textMuted,
            justifyContent: isUser ? 'flex-end' : 'flex-start',
          }}>
            {timestamp && <span>{timestamp}</span>}
            {isPending && <span style={{ fontSize: 11 }}>...</span>}
            {!isUser && tokensIn != null && (
              <span style={{ fontSize: 9, opacity: 0.6 }}>
                {tokensIn}+{tokensOut} tokens
                {costUsd != null && ` · $${costUsd.toFixed(4)}`}
                {durationMs != null && ` · ${(durationMs / 1000).toFixed(1)}s`}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
